<div class="description innerContainer" *ngIf="product">
  <h2 class="vc-title-m description__title" i18n="@@PRODUCT.DESCRIPTION.TITLE">Details</h2>
  <div class="description__container">
    <!-- SELLER -->
    <div class="description__container__seller">
      <vc-product-seller-block [product]="product" [sellerPro]="sellerPro"></vc-product-seller-block>
    </div>
    <!-- / SELLER -->
    <!-- PRODUCT DESCRIPTION -->
    <div class="description__container__core">
      <vc-product-seller-description [product]="product"></vc-product-seller-description>
      <vc-product-description-list
        [product]="product"
        [shipping]="shipping"
        [sizeGuide]="sizeGuide"
        (openConditionGuideModal)="conditionGuideModalComponent()"
      ></vc-product-description-list>
      <button class="description__discussionsBtn" (click)="openComments()">
        <vc-sprite-icons name="talk" class="description__discussionsIcon"></vc-sprite-icons>
        <span i18n="@@PRODUCT.DESCRIPTION.SEE_DISCUSSIONS_BTN" class="description__discussionsText"
          >Write a Comment...</span
        >
      </button>
    </div>
    <!-- / PRODUCT DESCRIPTION -->
    <!-- REASSURANCE -->
    <div *ngIf="!isServer" class="description__container__reassurance">
      <vc-desc-reassurance
        [product]="product"
        [shipping]="shipping"
        [user]="user"
        [paymentMethod]="paymentMethod"
        [directShippingEligible]="directShippingEligible"
      ></vc-desc-reassurance>
      <div class="description__legal">
        <span *ngIf="sellerPro; else legalPrivate" i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.LEGAL_PRO"
          >This item is offered by a professional seller. Its price has been suggested by its seller.</span
        >
        <ng-template #legalPrivate i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.LEGAL_PRIVATE"
          >This item is offered by an individual seller. Its price has been suggested by its seller.</ng-template
        >
      </div>
      <button *ngIf="isFrench" class="description__legalWarrantiesLink vc-link" (click)="openLegalWarrantiesModal()">
        Garanties légales
      </button>
      <button
        *ngIf="canReportProducts"
        class="description__reportLink vc-link"
        i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.REPORT"
      >
        Report this item
      </button>
    </div>
    <!-- / REASSURANCE -->
  </div>
  <!-- / ROW -->
</div>

<div [hidden]="true">
  <span i18n="@@PRODUCT.DESCRIPTION.TRANSLATED_BY_GOOGLE">Translated by Google</span>
  <span i18n="@@PRODUCT.DESCRIPTION.READ_MORE">Read more</span>
  <span i18n="@@PRODUCT.DESCRIPTION.READ_LESS">Read less</span>
  <span i18n="@@PRODUCT.DESCRIPTION.TRANSLATE_CANCEL">Untranslate</span>
  <span i18n="@@PRODUCT.DESCRIPTION.TRANSLATE">Translate</span>
</div>
